// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import AffectedPin from '@deere/cps-it.warranty-model-factory/lib/affected-pin';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import PipAffectedPinsListItem from './pip-affected-pins-list-item';

const PipAffectedPinsList = props =>
    <ul className='pip-affected-pins-list'>
        <ListViewShowMore
            initialShowItems={50}
            perMoreMultiplier={1.25}
            showAllOption={true}
            showPerMore={50}
            totalItems={props.affectedPins.length}
        >
            {props.affectedPins.map((pin, index) => (
                <PipAffectedPinsListItem
                    actions={props.actions}
                    daysLeft={props.daysLeft}
                    key={index}
                    metric={props.metric}
                    pin={pin}
                    pipId={props.pipId}
                />))
            }
        </ListViewShowMore>
    </ul>;

PipAffectedPinsList.displayName = 'PipAffectedPinsList';
PipAffectedPinsList.propTypes = {
    actions: PropTypes.object.isRequired,
    affectedPins: PropTypes.arrayOf(PropTypes.instanceOf(AffectedPin)).isRequired,
    daysLeft: PropTypes.number.isRequired,
    metric: PropTypes.string.isRequired,
    pipId: PropTypes.string.isRequired
};

export default PipAffectedPinsList;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-affected-pins-list.js